import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { getUserType } from "../../services/auth";

import Header from '../../components/header';
import TitlePage from '../../components/title-page';

import RELEASES from './data';

// Historial de versiones del portal. Solo lo ve un admin.
//
// La pagina no hace peticiones: el changelog es contenido fijo que vive en
// data.js. Antes montaba en cada carga un contador de publishers copiado de
// list-publishers que no pintaba nada aqui y que ademas reventaba por dentro.
export default class Releases extends Component {
	state = {
		notAdmin: false
	}

	componentDidMount() {
		//if page reloads without close any modal
		document.querySelector('body').classList.remove("no-scroll");

		if (getUserType() !== "admin") {
			this.setState({notAdmin: true});
		}
	}

	render() {
		// redirect if not admin user
		if (this.state.notAdmin) {
			return <Redirect to='/projects' />;
		}

		// La version vigente es la primera entrada del primer grupo. Sale de los
		// datos y no escrita a mano: es lo que casi todo el mundo viene a mirar,
		// asi que encabeza la pagina en vez de obligar a buscarla en la lista.
		const latest = RELEASES.length > 0 && RELEASES[0].entries.length > 0
			? RELEASES[0].entries[0]
			: null;

		const totalReleases = RELEASES.reduce(
			(count, group) => count + group.entries.filter(entry => entry.version).length,
			0
		);

		return (
			<div data-page="releases">
				<Header />

				<TitlePage title="Official Releases"/>

				<div className="container-fluid" data-component="page-list-content">
					<div className="container">
						{latest && (
							<section className="release-hero">
								<p className="hero-label">Current version</p>

								{/* Parrafo y no encabezado: esta misma version aparece abajo
									como h3 en la linea de tiempo, y repetirla en el esquema de
									encabezados la haria sonar como dos apartados distintos. */}
								<p className="hero-version">
									Seat7 Portal {latest.version}
									<span className="badge">Latest</span>
									{latest.build && <span className="badge">Build {latest.build}</span>}
								</p>

								<p className="hero-meta">
									Released {latest.date}
									<span className="hero-dot" aria-hidden="true">·</span>
									{latest.changes.length} change{latest.changes.length === 1 ? '' : 's'}
									<span className="hero-dot" aria-hidden="true">·</span>
									{totalReleases} releases listed
								</p>
							</section>
						)}

						<div className="releases-list">
							{RELEASES.map((group, groupIndex) => (
								<section className="release-group" key={`${group.title}-${groupIndex}`}>
									<h2 className="release-group-title">{group.title}</h2>

									<div className="release-timeline">
										{group.entries.map((entry, entryIndex) => {
											// "Latest" sale de la posicion: la primera entrada del
											// primer grupo es la mas reciente. Escrita a mano habia que
											// acordarse de quitarla de la anterior al publicar.
											const isLatest = groupIndex === 0 && entryIndex === 0;

											return (
												<article
													className={`release-entry ${isLatest ? 'is-latest' : ''}`}
													key={`${entry.date}-${entryIndex}`}
												>
													<span className="release-marker" aria-hidden="true"></span>

													<div className="release-card">
														<div className="release-head">
															{entry.version && (
																<h3 className="release-version">
																	Seat7 Portal {entry.version}

																	{isLatest && <span className="badge">Latest</span>}

																	{entry.build && (
																		<span className="badge">Build {entry.build}</span>
																	)}
																</h3>
															)}

															{/* La fecha iba en un <h5> y no es un encabezado, es
																el dato de cuando salio. Ademas saltaba de h3 a h5,
																que para un lector de pantalla es un nivel que
																falta. */}
															<p className="release-date">{entry.date}</p>
														</div>

														<ul className="release-changes">
															{entry.changes.map((change, changeIndex) => (
																<li key={changeIndex}>{change}</li>
															))}
														</ul>
													</div>
												</article>
											);
										})}
									</div>
								</section>
							))}
						</div>

						<footer className="releases-footer">
							<img
								src="https://seat7-emails.s3.amazonaws.com/Seat7_02.png"
								alt="Seat 7"
								width="50"
								height="50"
							/>

							{/* El año se calcula: estaba escrito a mano y se queda viejo solo. */}
							<p className="text">©{new Date().getFullYear()}. Seat7 Entertainment LLC.</p>
						</footer>
					</div>
				</div>
			</div>
		);
	}
}
